(() => {
  if (window.__imBundleComparisonInstalled) return;
  window.__imBundleComparisonInstalled = true;

  const handle = 'a-thrill-of-hope-advent-epiphany-bundle';
  const installed = new WeakSet();
  const pending = new WeakSet();
  const sameProductPath = (url) => url.pathname.replace(/\/$/, '').endsWith(`/products/${handle}`);

  const install = (section, selection, product) => {
    if (!section.isConnected || installed.has(section) || product?.handle !== handle
      || !Array.isArray(product.variants) || !Array.isArray(product.options)) return;

    const variants = product.variants;
    const optionCount = product.options.length;
    if (optionCount < 2 || variants.some((variant) => !Array.isArray(variant.options)
      || variant.options.length !== optionCount)) return;

    const tables = Array.from(section.querySelectorAll('.atoh')).map((table) => {
      const links = Array.from(table.querySelectorAll('a.b[href]')).map((link) => {
        const original = link.getAttribute('href');
        let url;
        try { url = new URL(original, window.location.href); } catch { return null; }
        if (url.origin !== window.location.origin || !sameProductPath(url)) return null;
        const reference = variants.find((variant) => String(variant.id) === url.searchParams.get('variant'));
        return reference ? { link, original, url, reference } : null;
      });
      if (links.length !== 4 || links.some((link) => !link)) return null;
      const possibleIndices = product.options.map((_, index) => index).filter((index) =>
        new Set(links.map(({ reference }) => reference.options[index])).size === links.length
        && links.every(({ reference }) => reference.options.every((value, otherIndex) =>
          index === otherIndex || value === links[0].reference.options[otherIndex])));
      return possibleIndices.length === 1 ? { table, links, bundleIndex: possibleIndices[0] } : null;
    }).filter(Boolean);
    if (!tables.length) return;
    installed.add(section);

    const selectedOptions = (event) => {
      const picker = selection.querySelector('options-selection');
      const controls = picker ? Array.from(picker.querySelectorAll('[data-variant-option]')) : [];
      if (controls.length) {
        const values = Array(optionCount).fill(null);
        controls.forEach((control) => {
          const index = Number(control.dataset.variantOptionIndex);
          if (!Number.isInteger(index) || index < 0 || index >= optionCount) return;
          const selected = control.matches('select') ? control
            : control.querySelector('input[type="radio"][data-variant-option-value]:checked');
          if (selected && selected.value !== 'not-selected') values[index] = selected.value;
        });
        return values;
      }
      const input = selection.querySelector('[data-variants]');
      const id = event?.target?.matches?.('[data-variants]') ? event.target.value
        : selection.getAttribute('variant') || input?.value;
      return variants.find((variant) => String(variant.id) === String(id))?.options || [];
    };

    const update = (event) => {
      if (!section.isConnected || !selection.isConnected) return;
      const values = selectedOptions(event);
      tables.forEach(({ links, bundleIndex }) => {
        links.forEach(({ link, original, url, reference }) => {
          const targetOptions = values.slice();
          targetOptions[bundleIndex] = reference.options[bundleIndex];
          const matches = variants.filter((variant) => variant.options.every((value, index) =>
            value === targetOptions[index]));
          if (matches.length !== 1) {
            link.setAttribute('href', original);
            return;
          }
          const target = new URL(url.href);
          const current = new URL(window.location.href);
          if (sameProductPath(current)) {
            new Set(current.searchParams.keys()).forEach((key) => {
              if (key === 'variant') return;
              if (key === 'preview_theme_id') target.searchParams.delete(key);
              if (!target.searchParams.has(key)) {
                current.searchParams.getAll(key).forEach((value) => target.searchParams.append(key, value));
              }
            });
          }
          target.searchParams.set('variant', String(matches[0].id));
          link.setAttribute('href', target.href);
        });
      });
    };

    selection.addEventListener('variant-change', update);
    selection.addEventListener('change', update, true);
    selection.addEventListener('input', update, true);
    tables.forEach(({ table }) => {
      ['pointerdown', 'click', 'auxclick', 'contextmenu', 'focusin', 'keydown'].forEach((type) => {
        table.addEventListener(type, update, true);
      });
    });
    window.addEventListener('pageshow', update);
    window.addEventListener('popstate', update);
    update();
  };

  const scan = () => {
    document.querySelectorAll('[data-section-type="static-product"][data-section-data]').forEach((script) => {
      const section = script.closest('.shopify-section');
      const selection = section?.querySelector('variant-selection[data-variant-selection]');
      if (!section || !selection || installed.has(section) || pending.has(section)
        || !section.querySelector('.atoh')) return;
      let product;
      try { product = JSON.parse(script.textContent).product; } catch { product = null; }
      if (product?.handle === handle && Array.isArray(product.variants)) {
        install(section, selection, product);
        return;
      }
      if (!window.customElements) return;
      pending.add(section);
      window.customElements.whenDefined('variant-selection').then(() => {
        if (!section.isConnected || typeof selection.getProduct !== 'function') return null;
        return selection.getProduct();
      }).then((nativeProduct) => {
        install(section, selection, nativeProduct);
      }).catch(() => {}).finally(() => pending.delete(section));
    });
  };

  document.addEventListener('shopify:section:load', scan);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', scan, { once: true });
  else scan();
})();
